import { useEffect } from "react";
import { actions, useAppDispatch, useAppSelector } from "../../../redux";

export const useFetchStakingData = () => {
  const dispatch = useAppDispatch();
  const { loading, isLogged } = useAppSelector((store) => store.user);

  useEffect(() => {
    if (isLogged && !loading) {
      dispatch(actions.staking.getStakingData());
      dispatch(actions.staking.getLockoutTime());
    }

    const intervalId = setInterval(() => {
      dispatch(actions.staking.refreshStakingData());
    }, 20000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
};
